export const createIframe = ({ id, src }: { id: string; src: string }): HTMLIFrameElement => {
    const iframe = document.createElement('iframe');
    iframe.id = id;
    iframe.style.height = '0px';
    iframe.style.width = '0px';
    iframe.style.position = 'absolute';
    iframe.style.left = '-9999px';
    iframe.src = src;
    document.body.appendChild(iframe);
    return iframe;
};
